// extracted by css-extract-rspack-plugin
export default {"downloadLink":"FileLink__downloadLink--VDwf9"};